import NodeEvents from 'events';
import * as Inovx from '@shared';
import HomeConstants from '../constants/HomeConstants';
import type { IHomeFacility } from '../constants/interfaces';

const EventEmitter = NodeEvents.EventEmitter;
const UrlUtilities = Inovx.Shared.Common.UrlUtilities;
const CHANGE_EVENT = 'HomeFacility.change';

let _facilities: IHomeFacility[] = [];

function fixThumbnailUrl(facility: IHomeFacility) {
    if (facility.ThumbnailImageUrl) {
        facility.ThumbnailImageUrl = UrlUtilities.getImageBaseUrl() + facility.ThumbnailImageUrl;
    }
}

const HomeFacilityStore = Object.assign({}, EventEmitter.prototype, {
    getAll(): IHomeFacility[] {
        return _facilities;
    },
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback: () => void) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback: () => void) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

Inovx.Shared.Flux.AppDispatcher.register((payload: any) => {
    if (payload.actionType === HomeConstants.HOME_FACILITY_GET_ALL) {
        _facilities = payload.data ?? [];
        _facilities.forEach(fixThumbnailUrl);
        HomeFacilityStore.emitChange();
    }
    return true;
});

export default HomeFacilityStore;
